import React from 'react';

export const FlaskConicalIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M8.5 2h7l5 12.5-1.5 6h-12l-1.5-6L8.5 2z"/>
        <path d="M10 16.5h4"/>
        <path d="M10 13h4"/>
        <path d="M10 9.5h4"/>
    </svg>
);